import { IRSState } from './types';

export const initialState: IRSState = {
  illegalStructures: [],
  buyAnalyticsFreeReportData: {
    name: '',
    date: '',
    url: '',
  },
  buyAnalyticsLegalDocsUrl: '',
  bestPlaceAnalyticsReportExampleUrl: '',
  bestPlaceReportLegalDocsUrl: '',
};

export function rsReducer(state: IRSState = initialState): IRSState {
  return state;
}
